import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ClientGroupLayer from "../components/ClientGroupLayer";

const ClientGroupPage = () => {
  return (
    <>
      <MasterLayout>
        <ClientGroupLayer />
      </MasterLayout>
    </>
  );
};

export default ClientGroupPage;
